import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
  },
  inn: {
    marginLeft: theme.spacing(1),
  },
}));

export default useStyles;
